
$(document).ready(function() {
  $(".become-btn").on("click", function() {
    // 获取目标元素的位置
    var targetPosition = $("#shopify-section-template--16776391459035__e4d721a6-cbd6-40de-8f88-704a6be59a7f").offset().top;
    
    // 缓慢滚动到目标位置
    $("html, body").animate({
      scrollTop: targetPosition
    }, 1000); // 1000表示滚动的时间，单位是毫秒
  });
});
